import type { Components } from '@mui/material/styles';

export default function MUISnackbar(): Components['MuiSnackbar'] {
  return {};
}
